import { jsx } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
import { instantSavingsStyles } from "./styles.js";
import { getFormattedPrice } from "../Price/lib.js";
const InstantSavings = ({
  displayDiscount,
  instantSavingsText,
  locale,
  partNumber,
  totalDiscount
}) => {
  if (!displayDiscount || !instantSavingsText || !totalDiscount || totalDiscount <= 0)
    return null;
  const formattedPrice = getFormattedPrice(locale, totalDiscount, true);
  return /* @__PURE__ */ jsx(
    Text,
    {
      sx: instantSavingsStyles,
      uniqueId: `instantSavings_${partNumber}`,
      variant: "t6",
      children: `${formattedPrice} ${instantSavingsText}`
    }
  );
};
export {
  InstantSavings
};
